import React from 'react'

function ChatMessage({ message }) {
  const isUser = message.role === 'user'

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-3`}>
      <div
        className={`
          max-w-[85%] rounded-2xl px-4 py-2.5
          ${isUser
            ? 'bg-gray-900 text-white'
            : 'bg-gray-100 text-gray-900'
          }
        `}
      >
        {message.text && (
          <div className="text-sm whitespace-pre-wrap leading-relaxed">
            {message.text}
          </div>
        )}
      </div>
    </div>
  )
}

export default ChatMessage
